import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  private readonly errorHandler = Sentry.createErrorHandler({
    showDialog: false,
    logErrors: true,
  });
  constructor() {}

  handleError(error: unknown): void {
    if (this.extractHttpError(error)) {
      return;
    }
    const capturedError = error instanceof Error ? error : new Error(String(error));
    this.errorHandler.handleError(capturedError);
  }

  private extractHttpError(error: unknown): HttpErrorResponse | null {
    if (error instanceof HttpErrorResponse) return error;
    if (!error || typeof error !== 'object') return null;
    const maybe = error as {
      rejection?: unknown;
      ngOriginalError?: unknown;
      originalError?: unknown;
    };
    if (maybe.rejection instanceof HttpErrorResponse) return maybe.rejection;
    if (maybe.ngOriginalError instanceof HttpErrorResponse) return maybe.ngOriginalError;
    if (maybe.originalError instanceof HttpErrorResponse) return maybe.originalError;
    return null;
  }
}
